import { Link, NavLink, useLocation } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { AuthContext } from "../contexts/AuthContext";
import { useWishlist } from "../contexts/WishlistContext";
import React,{useContext} from "react";

const MobileViewBottomNav = () => {
    const { isAuthenticated } = useContext(AuthContext);
    const currentTab = useLocation();
    const { cartCount } = useCart();
    const { wishlistCount } = useWishlist();
  
    return (
      <div className="d-md-none fixed-bottom bg-white border-top shadow-sm py-2">
        <div className="container d-flex justify-content-around align-items-center">
          {/* Home */}
          <Link
            to="/"
            className={`text-center text-decoration-none ${
              currentTab.pathname === "/" ? "text-main fw-bold" : "text-dark"
            }`}
          >
            <i className="ph ph-house fs-3"></i>
            <p className="small mb-0">Home</p>
          </Link>
  
          {/* Wishlist */}
          {/* Show wishlist only if user is authenticated */}
          {isAuthenticated && (
            <Link
              to="/wishlist"
              className={`text-center text-decoration-none position-relative ${
                currentTab.pathname === "/wishlist" ? "text-main fw-bold" : "text-dark"
              }`}
            >
              <i className="ph ph-heart fs-3"></i>
              <p className="small mb-0">Wishlist</p>
              <span className="badge bg-main-600 position-absolute top-0 start-100 translate-middle">
                {wishlistCount}
              </span>
            </Link>
          )}
  
          {/* Cart */}
          <Link
            to="/cart"
            className={`text-center text-decoration-none position-relative ${
              currentTab.pathname === "/cart" ? "text-main fw-bold" : "text-dark"
            }`}
          >
            <i className="ph ph-shopping-cart fs-3"></i>
            <p className="small mb-0">Cart</p>
            <span className="badge bg-main-600 position-absolute top-0 start-100 translate-middle">
              {cartCount}
            </span>
          </Link>
  
          {/* My Account */}
          <Link
            to="/account"
            className={`text-center text-decoration-none ${
              currentTab.pathname === "/account" ? "text-main fw-bold" : "text-dark"
            }`}
          >
            <i className="ph ph-user fs-3"></i>
            <p className="small mb-0">Account</p>
          </Link>
        </div>
      </div>
    );
  };
  
  export default MobileViewBottomNav;
  